import { useQuery } from '@tanstack/react-query';
import { accessAPI } from '@/lib/api';

// Who may sign up right now: "open", "invite_only" or "closed". Until it loads we assume invite-only.
export default function useAccessMode() {
  const { data } = useQuery({
    queryKey: ['public-access'],
    queryFn: async () => (await accessAPI.publicAccess()).data,
    staleTime: 60000,
    retry: 1,
  });
  return {
    mode: data?.mode || 'invite_only',
    termsText: data?.pilot_terms_text || '',
    loaded: !!data,
  };
}
